import React, { useEffect } from "react";
import { LoginBg } from "../assets/video";
import { FcGoogle } from "react-icons/fc";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { app } from "../config/firebase.config";
import { useNavigate } from "react-router-dom";
import { validateUser } from "../api";
import { actionType } from "../Context/reducer";
import { useStateValue } from "../Context/StateProvider";
import loglogo from "../assets/img/loglogo.png";
import night from "../assets/img/oluwami.jpg";
// import yanni from "../assets/yanni.mp3";

const Login = ({ setAuth }) => {
  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStateValue();

  const loginWithGoogle = async () => {
    await signInWithPopup(firebaseAuth, provider).then((userCred) => {
      if (userCred) {
        setAuth(true);
        window.localStorage.setItem("auth", "true");

        firebaseAuth.onAuthStateChanged((userCred) => {
          if (userCred) {
            userCred.getIdToken().then((token) => {
              window.localStorage.setItem("auth", "true");
              validateUser(token).then((data) => {
                dispatch({
                  type: actionType.SET_USER,
                  user: data,
                });
              });
            });
            navigate("/", { replace: true });
          } else {
            setAuth(false);
            dispatch({
              type: actionType.SET_USER,
              user: null,
            });
            navigate("/login");
          }
        });
      }
    });
  };

  useEffect(() => {
    if (window.localStorage.getItem("auth") === "true")
      navigate("/", { replace: true });
  }, []);

  return (
    <div className="md:flex ">
      <div className="z-50 hidden md:inline bg-slate-900 text-center h-screen w-[80%]">
        <img
          src={night}
          alt="night"
          className="hidden md:inline h-[90%] rounded-3xl mt-[6%]"
        />
      </div>
      <div className="relative w-screen h-screen">
        <video
          src={LoginBg}
          type="video/mp4"
          muted
          loop
          autoPlay
          className="w-full h-full object-cover"
        />
        {/* <audio src={yanni} type="audio/mp3" loop autoPlay /> */}
        {/* <audio src={yanni} autoPlay controls loop /> */}
        <div className="absolute inset-0 items-center flex bg-darkOverlay justify-center p-4">
          <img
            src={loglogo}
            className="absolute top-56 animate-bounce  rounded-xl p- w-40"
            alt=""
          />
          <div className="w-full md:w-[20%] h-[8%] bg-gray-400 shadow-2xl backdrop-blur-md flex flex-col items-center justify-center z-50 rounded-sm">
            <div
              className=" flex items-center justify-center gap-2 px-4 py-2 bg-gray-300 rounded-md cursor-pointer hover:shadow-md hover:bg-white duration-100 ease-in-out transition-all"
              onClick={loginWithGoogle}
            >
              <FcGoogle className="text-xl" />
              sign in
            </div>
          </div>
          <div className="absolute top-80 md:top-96 p-8">
            <img
              src={night}
              alt=""
              className="md:hidden w-40 rounded-2xl mt-[7%] ml-[27%] h-44  "
            />
            <p className="text-white font-extrabold text-2xl text-transparent bg-clip-text bg-gradient-to-tr from-white via-red-600 to-white">
              From the melody maker of the new kingdom of God
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
